<app-user-requests-table [requests]="requests | async"
                         (take)="handleRequest($event)"
                         (untake)="untakeRequest($event)"
                         (accept)="toAccept = $event"
                         (detail)="toView = $event"
                         (partialAccept)="toPartialAccept = $event"
                         (reject)="toReject = $event">
</app-user-requests-table>

<app-user-requests-view
  [categories]="categories"
  [request]="toView"
  [crmUrl]="crmUrl | async"
  (cancel)="toView = undefined"/>

<app-user-requests-accept
  [crmUrl]="crmUrl | async"
  [categories]="categories"
  [request]="toAccept"
  (submit)="doAccept($event)"
  (cancel)="toAccept = undefined"/>

<app-user-requests-reject
  [crmUrl]="crmUrl | async"
  [categories]="categories"
  [request]="toReject"
  (submit)="doReject($event)"
  (cancel)="toReject = undefined"/>

<app-user-requests-partial-accept
  [crmUrl]="crmUrl | async"
  [categories]="categories"
  [request]="toPartialAccept"
  (submit)="doPartialAcceptRequest($event)"
  (cancel)="toPartialAccept = undefined"/>

